import React, { useState } from 'react'
import styled from 'styled-components'
import { TableCell, TableRow } from 'grommet'
import colors from '@constants/colors'
import * as Utils from '@services/utils'
import { completionDateFormat } from '@services/dances'

export const getCellValue = (row, col, onClick, expanded) => {
    if (col.cell && typeof col.cell === 'function') {
        return col.cell(row, col, onClick, expanded)
    }
    let prop = row[col.property]
    if (col.subProperty) {
        let subproperties = Array.isArray(col.subProperty)
            ? col.subProperty
            : [col.subProperty]
        return subproperties.map((sp) => row[col.property][sp]).join(' ')
    }
    if (typeof prop === 'object') {
        return prop && JSON.stringify(prop)
    }
    return prop
}

export default ({ row, rowIndex, columns, ExpandedRowComponent, page }) => {
    const [expanded, setExpanded] = useState(false)
    const [expandedFromPageNum, setExpandedFromPageNum] = useState(null)
    expanded && expandedFromPageNum !== page && setExpanded(false)

    const Expansion =
        expanded && ExpandedRowComponent ? ExpandedRowComponent : TableRow

    const handleRowClick = () => {
        ExpandedRowComponent && setExpanded(!expanded)
        setExpandedFromPageNum(page)
    }

    return [
        <StyledTableRow
            clickable={ExpandedRowComponent}
            onClick={handleRowClick}
            border="bottom"
            key={'row-data-' + rowIndex}
        >
            {columns.map((col, i) => {
                if (!col.hidden) {
                    return (
                        <StyledTableCell
                            key={'col-data-' + i}
                            align={col.align}
                        >
                            {/* {col.property !== 'request_date'
                                ? getCellValue(row, col, null, expanded)
                                : Utils.formatDate(
                                      getCellValue(row, col, null, expanded),
                                      completionDateFormat
                                  )} */}
                            {getCellValue(row, col, null, expanded)}
                        </StyledTableCell>
                    )
                }
            })}
        </StyledTableRow>,
        <tr key={'row-data-expaned-' + rowIndex}>
            {expanded && (
                <InnerTableContainer colSpan={columns.length}>
                    <Expansion item={row} expanded={expanded} />
                </InnerTableContainer>
            )}
        </tr>,
    ]
}

const StyledTableRow = styled(TableRow)`
    border-bottom: 1px solid grey;
    cursor: ${(p) => p.clickable && 'pointer'};
    &:hover {
        background-color: WhiteSmoke;
    }
`

const StyledTableCell = styled(TableCell)`
    font-size: 14px;
    align-items: ${(p) =>
        p.align === 'center' ? 'center' : 'flex-' + p.align};
`

const InnerTableContainer = styled.td`
    /* padding-top: 8px; */
    background-color: ${colors.APP_GRAY_LIGHT};
`
